import ManualTableList from './ManualTableList.vue';

export default ManualTableList;
